<template>
    <section class="publication">
        <div class="container">
            <div class="row">
                <div class="col-md-12">

                    <div class="publication__heading d-flex">
                        <publication-progress :step-info="{ info: currentStepComponent.progress, count: initial.length }" />
                        <h2 v-if="currentStepComponent">{{$store.getters.t(currentStepComponent.title)}}</h2>
                        <span v-if="currentStepComponent.subtitle" class="publication__subtitle">{{$store.getters.t(currentStepComponent.subtitle)}}</span>
                        <button v-if="!currentStepComponent.required" type="button" class="btn publication__btn"
                                @click.prevent="handleTransform('increment')"
                        >{{$store.getters.t('common_skip')}}</button>
                    </div>

                </div>
            </div>

            <div class="publication__content">
                <div v-show="rerender" class="publication__content-placeholder"></div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="publication__slider" ref="slider" :style="{maxHeight: `${sliderHeight}px`}" >

                            <div class="publication__slider-track clearfix"
                                 :style="{width: `${trackWidth}px`, transform: `translateX(${trackTransform}px)`,
                                 transition: rerender ? 'none' : 'transform 0.4s ease'}">

                                <template v-if="initial.length">

                                    <template v-for="(s, idx) in initial">

                                        <div class="publication__slider-slide" ref="slides" :style="{width: `${slideWidth}px`}" :key="idx">
                                            <component :server="{...server, idx, createdTarget: createdId}" @parent-update="stepUpdate" ref="stepRefs" :is="s.component.name"></component>
                                        </div>

                                    </template>

                                </template>

                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="row" v-if="step < initial.length - 1">
                <div class="col-md-12">
                    <div class="publication__nav d-flex">
                        <button type="button" class="btn publication__btn" v-if="step >= 1"
                                @click.prevent="handleTransform('decrement')"
                        >{{$store.getters.t('common_back')}}</button>
                        <button type="button" class="btn publication__btn publication__btn--primary"
                                @click.prevent="handleTransform('increment')" v-if="step < initial.length - 2"
                                >{{$store.getters.t('common_forward')}}</button>
                        <button type="button" class="btn publication__btn publication__btn--primary" :disabled="disableActionButton"
                                @click.prevent="submitForm" v-if="currentStepComponent.component.name === 'PublicationEdit'"
                                >
                            {{
                                (currentStepComponent.valid && !disableActionButton  && $store.getters.t('publication_submit_save_and_moderate')) ||
                                (disableActionButton && $store.getters.t('publication_submit_wait_check')) ||
                                $store.getters.t('publication_submit_fix_errors_retry')
                            }}
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>


<script>
import {paginationScrollTo} from '../../helpers/helpers';

import createPetWithDonations from "./createPetWithDonations";
import createPetWithoutDonations from "./createPetWithoutDonations";
import editPet from "./editPet";

import SliderMixin from '../mixins/SliderMixin';
import StateMixin from "../mixins/StateMixin";

import PublicationProgress from '../PublicationProgress';
import PublicationCreatePet from './PublicationCreatePet';
import SelectLocation from './SelectLocation';
import PetCategories from './PetCategories';
import PetProfile from './PetProfile';
import PublicationPreview from './PublicationPreview';
import PublicationPreviewAvatar from './PublicationPreviewAvatar';
import PublicationSliderGallery from './PublicationSliderGallery';
import PetFilters from './PetFilters';
import PublicationDonations from './PublicationDonations';
import PublicationEdit from './PublicationEdit';
import PublicationSuccess from './PublicationSuccess';

export default {
    props: ['server'],
    mixins: [SliderMixin, StateMixin],
    provide() {
        return {
            step: () => this.step
        };
    },
    components: {
        PublicationProgress, PublicationCreatePet, SelectLocation, PetCategories, PetProfile, PublicationPreview,
        PublicationPreviewAvatar, PublicationSliderGallery, PetFilters, PublicationDonations, PublicationEdit,
        PublicationSuccess
    },
    name: "index",
    data(){

        return{
            slides: (this.createCategory === 'fundraising' &&  createPetWithDonations) ||  createPetWithoutDonations,
            rerender: false,
            merge_model: false,
            createdId: null,
            STORE_ENDPOINT:  this.server.model ? `/pets/${this.server.model.id}/update` : '/pets/store',
        }

    },

    created() {

        this.CREATE_STATE_BY_KEY('pet');

        if (
            this.server.model
            && Object.keys(this.server.model).length
            && window.location.pathname.search(/\/pet\/\d+$/g)
        ) {

            this.merge_model = true;

            const prepareState = {

                not_moderated_fields: this.server.model['not_moderated_fields'].concat([
                    'create_category', 'selectedCity', 'avatarPath', 'previewImages', 'petAvatar',
                    'not_moderated_fields'
                ]),

                petAvatar: `/storage${this.server.model.avatar.path}`,
                avatarPath: `/storage${this.server.model.avatar.path}`,

                images: [],

                previewImages: this.server.model['images'].map( photo => {
                    return {
                        id: photo.id,
                        base64: '/storage' + photo.path,
                        name: (
                            (arr) => { return arr[ arr.length - 1 ] }
                        )(photo.path.split('/')),
                    }
                } ),

                filters: Array.isArray( this.server.model['filters'] ) ?
                    this.server.model['filters'].map( el => { return el.id } ) : [],

                selectedCity: { ...this.server.model.city },

                create_category: parseFloat(this.server.model[ 'need_sum' ]) > 0 ? 'fundraising' : 'device',

                to_children: this.server.model['to_children'] || 'null',
                to_dogs: this.server.model['to_dogs'] || 'null',
                to_cats: this.server.model['to_cats'] || 'null',
                enrichment: this.server.model['enrichment'] || 'null',
                human_sociability: this.server.model['human_sociability'] || 'null',

            };


            Object.keys(this.GET_STATE).forEach( _k => {

                if ( ! this.server.model.hasOwnProperty( _k ) || prepareState.hasOwnProperty( _k ) ) return;

                prepareState[ _k ] = this.server.model[ _k ];

            });

            this.slides = editPet;
            this.SET_STATE_BY_MODEL( prepareState )

        }
    },

    computed: {
        createCategory(){ return this.GET_BY_KEY('create_category') },

        filters: {
            get() { return this.GET_BY_KEY('filters') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'filters', data: val})
            }
        },

        need_sum: {
            get() { return this.GET_BY_KEY('need_sum') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'need_sum', data:  val})
            }
        },

    },

    watch:{
        createCategory: {
            handler(val){


                if( ! this.merge_model ){
                    this.slides = this.createCategory === 'fundraising' ? createPetWithDonations : createPetWithoutDonations;
                }

                this.handleSliderHeight();
                this.handleSelected();

                if(this.step > 0){
                    new Promise( res => {
                        this.rerender = true;
                        if( this.createCategory ) {
                            this.handleTransform(this.createCategory === 'fundraising' ? 'increment' : 'decrement', true)
                        }
                        res();
                    }).then(() => { setTimeout(() => { this.rerender = false }, 1500) })

                }

            },
            deep: true
        },

    },

    methods:{

        async submitForm(){

            this.disableActionButton = true;

            const valid = this.$refs.stepRefs[ this.step ].isValid()

            if ( ! valid ) {
                this.handleSliderHeight();
                this.disableActionButton = false;
            }

            if ( valid ){

                if (
                    this.server.model
                    && this.server.model.filters
                    && this.server.model.filters.length
                    && ! this.filters.length
                ) this.filters = 'null';

                if( this.createCategory === 'device' && this.need_sum ) this.need_sum = 0;

                if( this.need_sum ) this.need_sum = parseFloat( this.need_sum ).toFixed( 2 );

                const result = await this.ACTION_STORE( this.STORE_ENDPOINT );

                if( result.success ) {

                    this.createdId = result.data.id;

                    new Promise(res => {

                        paginationScrollTo('.publication__heading');
                        setTimeout(() => {
                            res();
                        }, 700)

                    }).then( () => {
                        this.handleTransform( 'increment' )
                        this.slides[ this.step ].valid = result
                    } )

                } else {
                    this.disableActionButton = false;

                    if (result && result.errors) {
                        for (let key in result.errors) {
                            var message = result.errors[key];
                            if (key.startsWith('images.') && message == 'The ' + key + ' failed to upload.') {
                                alert(this.$store.getters.t('publication_image_too_large_5mb'));
                            }
                            if(key == 'avatar' && message == ('The ' + key + ' failed to upload.')) {
                                alert(this.$store.getters.t('publication_avatar_too_large_5mb'));
                            }
                        }
                    }
                }


            }

        }

    }
}
</script>

<style lang="scss"></style>
